import { Button, Checkbox, notification } from 'antd';
import { Fragment, PureComponent, ReactNode } from 'react';
import { batch, connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../../../store/actions';
import { upsertLabVital } from '../../../store/actions/prescriptionPad';
import { GlobalState } from '../../../store/reducers';
import { PatientDetailsMR } from '../../../store/reducers/prescriptionPad';
import { getAllPtIdsPatient, getPatientDetailsMR } from '../../../store/selectors/prescriptionPad';
import { LabVitalEntity } from '../../../store/types/prescription';
import MedicalRecord from '../../MedicalRecord';
import MREmpty from './MREmpty';
import { track } from '../../../tracking';
import { medicalBookIcon } from '../../../components/common/Icons';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouterProps } from './routerProps';
import { changePathAndFocus } from './magicBoxUtils';


interface Props extends RouteComponentProps<RouterProps> {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    mr?: PatientDetailsMR;
    allPtIds?: string[];
}

type State = {
    profileFilterValue: 'profile' | 'all';
};

class MR extends PureComponent<Props, State> {
    state: State = {
        profileFilterValue: 'profile',
    };
    handleGoToMedicalRecords = () => {
        const { pxId, pxState } = this.props.match.params;
        changePathAndFocus('medical-records', this.props.history, pxId, pxState, 'medical-records',undefined, undefined, true);
    }
    copyToPrescription = (labVitals: LabVitalEntity[]) => {
        track('COPY_SMART_VITALS_TO_RX', { from: 'prescription-pad' });
        const { dispatch } = this.props;
        batch(() => {
            labVitals.forEach((l) => dispatch(upsertLabVital(l)));

            notification.success({
                message: `Copied to Prescription`,
                duration: 5,
            });
        });
        return;
    };

    onProfileFilterChange = (value: 'profile' | 'all') => {
        this.setState({ profileFilterValue: value });
        return;
    };

    render(): ReactNode {
        const { mr, allPtIds } = this.props;
        const { profileFilterValue } = this.state;

        if (!mr || !mr.data || mr.data.length === 0) {
            return <MREmpty />;
        }

        const ptIds = new Set(allPtIds);

        let list = mr?.data;
        let diffCount = 0;

        if (profileFilterValue === 'profile') {
            list = list.filter((item) => ptIds?.has(item.oid || ''));
            diffCount = mr?.data.length - list.length;
        } else {
            diffCount = mr?.data.length - list.filter((item) => ptIds?.has(item.oid || '')).length;
        }

        return (
            <Fragment>
                {list.length ? (
                    <div className="space-y-8 py-18 px-13 pt-9 pb-48">
                        {list.map((item) => (
                            <MedicalRecord
                                documentFolder={item}
                                copyToPrescription={this.copyToPrescription}
                                containerCss="bg-darwin-neutral-50"
                            />
                        ))}
                        <div style={{ width: 'fit-content !important' }} className="pt-40 mx-auto">
                            <Button
                                onClick={this.handleGoToMedicalRecords}
                                className="flex w-full py-10 rounded-4 justify-center flex-row items-center gap-4"
                            >
                                {medicalBookIcon()}
                                <span className="text-14">All Medical Records</span>
                            </Button>
                        </div>
                    </div>
                ) : (
                    <MREmpty />
                )}

                {diffCount > 0 && (
                    <div className="p-8 select-none absolute bottom-0 w-full bg-darwin-neutral-50 rounded-b-8">
                        <Checkbox
                            onChange={(e) =>
                                this.onProfileFilterChange(e.target.checked ? 'all' : 'profile')
                            }
                            checked={profileFilterValue === 'all'}
                        >
                            +{diffCount} records from other profiles
                        </Checkbox>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default connect((state: GlobalState) => ({
    mr: getPatientDetailsMR(state),
    allPtIds: getAllPtIdsPatient(state),
}))(withRouter(MR));
